import moment from 'moment';

export function formatDate(date, format) {
  if (typeof date === 'number') {
    return moment.unix(date).format(format);
  }

  return moment(date).format(format);
}

export function fromNow(date) {
  let momentDate;

  if (typeof date === 'number') {
    momentDate = moment.unix(date);
  } else {
    momentDate = moment(date);
  }

  return momentDate.fromNow();
}

export function now(isUnix = true) {
  if (isUnix) {
    return moment().unix();
  }

  return moment();
}

export function setLocale(locale) {
  moment.locale(locale);
}

export function unix(date) {
  return moment(date).unix();
}
